// JS for slider-container-hoodie-2
const slideContainerHoodie2 = document.querySelector('.slider-container-hoodie-2');

// URLs for desktop images
const desktopImageUrlsHoodie2 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16_3.gif?v=1726126012',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16_4.png?v=1726126018',

];

// URLs for mobile images
const mobileImageUrlsHoodie2 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile7.gif?v=1726128710',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile_8.png?v=1726128290',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile_9.png?v=1726128290',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile_10.png?v=1726128290',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile_11.png?v=1726128290',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/Club9.16Mobile_12.png?v=1726128290'
];

function loadImagesHoodie2() {
    const isMobile = window.innerWidth <= 768;
    slideContainerHoodie2.innerHTML = '';

    if (isMobile) {
        mobileImageUrlsHoodie2.forEach(url => {
            const mobileImage = document.createElement('img');
            mobileImage.src = url;
            mobileImage.alt = 'Mobile image';
            mobileImage.className = 'mobile-image-hoodie-2';
            slideContainerHoodie2.appendChild(mobileImage);
        });
    } else {
        desktopImageUrlsHoodie2.forEach(url => {
            const desktopImage = document.createElement('img');
            desktopImage.src = url;
            desktopImage.alt = 'Desktop image';
            desktopImage.className = 'desktop-image-hoodie-2';
            slideContainerHoodie2.appendChild(desktopImage);
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    loadImagesHoodie2();
    window.addEventListener('resize', loadImagesHoodie2);

    const targetEndTimeHoodie2 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdownHoodie2() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTimeHoodie2 - currentTime;

        if (timeDifference <= 0) {
            document.getElementById('countdown-hoodie-2').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown-hoodie-2').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdownHoodie2, 1000);
    }

    updateCountdownHoodie2();
});
